import { RED, INK, GREY, IVORY, DARK, LINE, paras, compact, hr, vr, dot } from "./povPages";

// Deuxième document : coordonnées exactes du PDF (canevas 960 x 540).
export function buildPovPages2(insight) {
  const b = insight.blocks;
  const pages = [];

  const eyebrow = (text) => ({ x: 44, y: 46, size: 8.5, bold: true, color: RED, upper: true, ls: "0.14em", text });
  const title = (text, w, size = 25, lh = 1.12) => ({ x: 44, y: 78, w, size, serif: true, bold: true, color: INK, lh, text });
  const lead = (text, y, w, size = 10.8) => ({ x: 44, y, w, size, color: INK, lh: 1.47, text });
  const itemsTitle = (text, x = 525, y = 189, w = 330) => ({ x, y, w, size: 17, serif: true, bold: true, color: INK, lh: 1.2, text });
  const footnote = (text, w = 560) => ({ x: 44, y: 495, w, size: 6.4, color: GREY, lh: 1.4, text });

  // 01 — couverture
  pages.push({
    bg: DARK,
    bar: RED,
    barW: 14,
    image: { src: insight.image, x: 505, y: 0, w: 455, h: 540 },
    rects: [hr(54, 372, 385, 3)],
    items: [
      { x: 54, y: 137, w: 425, size: 30, serif: true, bold: true, color: "#ffffff", lh: 1.13, text: insight.title },
      { x: 54, y: 412, w: 425, size: 15.5, bold: true, color: "#ffffff", lh: 1.3, text: insight.subtitle },
    ],
  });

  // 02 — introduction
  {
    const k = b[0];
    const [p1, p2] = paras(k.lead);
    pages.push({
      rects: [
        hr(44, 916, 138),
        { x: 486, y: 185, w: 430, h: 277, fill: IVORY },
        { x: 486, y: 185, w: 5, h: 277, fill: RED },
      ],
      items: [
        eyebrow(k.eyebrow),
        title(k.title, 830),
        lead(p1, 187, 398, 11.1),
        lead(p2, 329, 398, 11.1),
        { x: 526, y: 229, w: 345, size: 24, serif: true, bold: true, color: INK, lh: 1.21, text: k.quote },
        { x: 526, y: 347, w: 345, size: 11, color: GREY, lh: 1.45, text: k.after },
      ],
    });
  }

  // 03 — synthèse
  {
    const k = b[1];
    const items = [eyebrow(k.eyebrow), title(k.title, 620)];
    k.items.forEach((it, i) => {
      const y = 191 + 79 * i;
      const n = String(i + 1).padStart(2, "0");
      items.push({ x: 44, y: y + 1, size: 10, bold: true, color: RED, text: n, desktopOnly: true });
      items.push({ x: 102, y, w: 330, size: 14.2, bold: true, color: INK, lh: 1.19, text: it.label, mobileNum: n });
      items.push({ x: 460, y: y - 2, w: 435, size: 9.8, color: GREY, lh: 1.43, text: it.text });
    });
    pages.push({ rects: [hr(44, 916, 138), ...[233, 312, 391].map((y) => hr(102, 890, y, 0.7, LINE))], items });
  }

  // 04 — repères chiffrés
  {
    const k = b[2];
    const items = [
      eyebrow(k.eyebrow),
      title(k.title, 860),
      { x: 44, y: 143, w: 820, size: 10.3, color: GREY, lh: 1.4, text: k.lead },
    ];
    [44, 336, 628].forEach((x, i) => {
      items.push({ x, y: 210, w: 260, size: 30, serif: true, bold: true, color: i === 0 ? RED : INK, lh: 1.1, text: k.items[i].label });
      items.push({ x, y: 267, w: 238, size: 10, color: GREY, lh: 1.4, text: k.items[i].text });
    });
    items.push({ x: 44, y: 394, w: 645, size: 19, serif: true, bold: true, color: INK, lh: 1.2, text: k.after });
    items.push(footnote(k.footnote));
    pages.push({ rects: [hr(44, 916, 160), vr(307, 203, 338), vr(599, 203, 338), hr(44, 916, 361, 0.8, LINE)], items });
  }

  // 05 / 09 / 13 — ouvertures de partie
  const part = (k) => ({
    bg: "#0a0a0a",
    bar: RED,
    barW: 15,
    image: { src: k.image, x: 0, y: 0, w: 960, h: 540, overlay: true },
    rects: [hr(55, 390, 294, 0.8, "#ffffff")],
    items: [
      { x: 55, y: 130, w: 690, size: 36, serif: true, bold: true, color: "#ffffff", lh: 1.1, text: k.title },
      { x: 55, y: 321, w: 540, size: 13, color: "#ffffff", lh: 1.38, text: k.lead },
    ],
  });

  pages.push(part(b[3]));

  // 06 — inférence
  {
    const k = b[4];
    const [p1, p2] = paras(k.lead);
    const items = [eyebrow(k.eyebrow), title(k.title, 810), lead(p1, 172, 400), lead(p2, 338, 400), itemsTitle(k.itemsTitle)];
    k.items.forEach((it, i) => {
      const y = 233 + 60 * i;
      const n = String(i + 1).padStart(2, "0");
      items.push({ x: 525, y: y + 1, size: 8, bold: true, color: RED, text: n, desktopOnly: true });
      items.push({ x: 570, y, w: 115, size: 11, bold: true, color: INK, lh: 1.2, text: it.label, mobileNum: n });
      items.push({ x: 690, y: y - 1, w: 195, size: 9, color: GREY, lh: 1.44, text: it.text });
    });
    pages.push({ rects: [hr(44, 916, 138), ...[261, 321, 381].map((y) => hr(570, 880, y, 0.6, LINE))], items });
  }

  // 07 — temporalités
  {
    const k = b[5];
    pages.push({
      items: [
        eyebrow(k.eyebrow),
        title(k.title, 790),
        lead(k.lead, 172, 400, 11),
        itemsTitle(k.itemsTitle, 500, 187, 290),
        { x: 500, y: 240, w: 300, size: 11, bold: true, color: GREY, text: k.items[0].label },
        { x: 500, y: 266, w: 340, size: 24, serif: true, bold: true, color: INK, lh: 1.2, text: k.items[0].text },
        { x: 500, y: 341, w: 320, size: 11, bold: true, color: GREY, text: k.items[1].label },
        { x: 500, y: 367, w: 355, size: 24, serif: true, bold: true, color: RED, lh: 1.2, text: k.items[1].text },
        { x: 44, y: 389, w: 400, size: 11, bold: true, color: INK, lh: 1.45, text: k.after },
        footnote(k.footnote, 330),
      ],
      rects: [hr(44, 916, 138), hr(500, 870, 310, 0.8, LINE)],
    });
  }

  // 08 — chaîne interdépendante
  {
    const k = b[6];
    const rects = [hr(44, 916, 138)];
    const items = [
      eyebrow(k.eyebrow),
      title(k.title, 850, 23, 1.14),
      lead(k.lead, 172, 385, 11),
      itemsTitle(k.itemsTitle, 500, 187, 300),
    ];
    k.items.forEach((it, i) => {
      const y = 223 + 60 * i;
      rects.push(dot(507, y, 22, i === 2 ? RED : DARK));
      if (i < 3) rects.push(vr(518, y + 23, y + 58, 1.2, LINE));
      items.push({ x: 548, y: y + 4, w: 150, size: 11, bold: true, color: INK, lh: 1.2, text: it.label });
      items.push({ x: 690, y: y + 3, w: 200, size: 9, color: GREY, lh: 1.44, text: it.text });
    });
    items.push({ x: 44, y: 339, w: 345, size: 17, serif: true, bold: true, color: INK, lh: 1.24, text: k.after });
    pages.push({ rects, items });
  }

  pages.push(part(b[7]));

  // 10 — choisir selon la fonction
  {
    const k = b[8];
    const [p1, p2] = paras(k.lead);
    const items = [eyebrow(k.eyebrow), title(k.title, 840, 23, 1.14), lead(p1, 172, 415), lead(p2, 336, 415), itemsTitle(k.itemsTitle, 525, 189, 300)];
    k.items.forEach((it, i) => {
      const y = 231 + 60 * i;
      items.push({ x: 525, y, w: 180, size: 10.5, bold: true, color: INK, lh: 1.2, text: it.label });
      items.push({ x: 710, y: y - 1, w: 205, size: 9.2, color: GREY, lh: 1.4, text: it.text });
    });
    pages.push({ rects: [hr(44, 916, 138), ...[260, 320, 380].map((y) => hr(525, 875, y, 0.6, LINE))], items });
  }

  // 11 — densité électrique
  {
    const k = b[9];
    pages.push({
      rects: [hr(44, 916, 138), { x: 44, y: 305, w: 410, h: 118, fill: IVORY }],
      items: [
        eyebrow(k.eyebrow),
        title(k.title, 870, 23, 1.14),
        lead(k.lead, 172, 420, 11),
        { x: 68, y: 333, w: 350, size: 15, serif: true, bold: true, color: INK, lh: 1.27, text: k.quote },
        itemsTitle(k.itemsTitle, 525, 189, 335),
        { x: 525, y: 251, w: 295, size: 10.5, color: GREY, lh: 1.44, text: k.asideText },
        { x: 525, y: 358, w: 335, size: 11, bold: true, color: RED, lh: 1.45, text: k.highlight },
        footnote(k.footnote, 460),
      ],
    });
  }

  // 12 — résilience
  {
    const k = b[10];
    const [p1, p2] = paras(k.lead);
    const items = [eyebrow(k.eyebrow), title(k.title, 830), lead(p1, 172, 400, 10.9), lead(p2, 320, 400, 10.9)];
    k.items.forEach((it, i) => {
      const y = 199 + 68 * i;
      const n = String(i + 1).padStart(2, "0");
      items.push({ x: 525, y: y + 1, size: 8, bold: true, color: RED, text: n, desktopOnly: true });
      items.push({ x: 570, y, w: 125, size: 11, bold: true, color: INK, lh: 1.2, text: it.label, mobileNum: n });
      items.push({ x: 700, y: y - 1, w: 190, size: 9, color: GREY, lh: 1.44, text: it.text });
    });
    pages.push({ rects: [hr(44, 916, 138), ...[232, 300, 368].map((y) => hr(570, 880, y, 0.6, LINE))], items });
  }

  pages.push(part(b[11]));

  // 14 — capacités essentielles
  {
    const k = b[12];
    const [p1, p2] = paras(k.lead);
    const items = [eyebrow(k.eyebrow), title(k.title, 800, 23, 1.14), lead(p1, 172, 420, 10.7), lead(p2, 342, 420, 10.7), itemsTitle(k.itemsTitle, 525, 189, 290)];
    k.items.forEach((it, i) => {
      const y = 232 + 50 * i;
      items.push({ x: 525, y, w: 135, size: 10.5, bold: true, color: INK, lh: 1.2, text: it.label });
      items.push({ x: 665, y: y - 1, w: 200, size: 9, color: GREY, lh: 1.4, text: it.text });
    });
    pages.push({ rects: [hr(44, 916, 138), ...[255, 305, 355, 405].map((y) => hr(525, 875, y, 0.6, LINE))], items });
  }

  // 15 — agenda de direction
  {
    const k = b[13];
    const [p1, p2] = paras(k.lead);
    const items = [eyebrow(k.eyebrow), title(k.title, 755), lead(p1, 172, 400), lead(p2, 327, 400), itemsTitle(k.itemsTitle, 525, 189, 260)];
    k.items.forEach((it, i) => {
      const y = 235 + 51 * i;
      const n = String(i + 1).padStart(2, "0");
      items.push({ x: 525, y: y + 1, size: 8, bold: true, color: RED, text: n, desktopOnly: true });
      items.push({ x: 570, y, w: 340, size: 11.1, bold: true, color: INK, lh: 1.2, text: it.label, mobileNum: n });
    });
    pages.push({ rects: [hr(44, 916, 138), ...[256, 307, 358, 409].map((y) => hr(570, 875, y, 0.6, LINE))], items });
  }

  // 16 — conclusion
  {
    const k = b[14];
    pages.push({
      bg: DARK,
      bar: RED,
      barW: 15,
      rects: [hr(54, 388, 390, 3)],
      items: [
        { x: 54, y: 76, size: 9, bold: true, color: "#d6cec6", upper: true, ls: "0.16em", text: k.eyebrow },
        { x: 54, y: 127, w: 830, size: 31, serif: true, bold: true, color: "#ffffff", lh: 1.16, text: k.title },
        { x: 54, y: 274, w: 760, size: 18, bold: true, color: "#e8e0d8", lh: 1.33, text: k.lead },
        { x: 54, y: 419, w: 760, size: 11.5, color: "#cfc7bf", lh: 1.45, text: k.after },
      ],
    });
  }

  return pages.map((p) => compact(p));
}
